import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { style: {"position":"absolute","top":"65px","left":"0","right":"0","bottom":"10px","overflow-y":"scroll"} }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "mt-5 pb-0" }
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = { class: "d-flex w-30 align-center px-4" }
const _hoisted_6 = { class: "px-4 py-2 text-center w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_main_app_bar = _resolveComponent("main-app-bar")!
  const _component_v_carousel_item = _resolveComponent("v-carousel-item")!
  const _component_v_carousel = _resolveComponent("v-carousel")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_connection_row = _resolveComponent("connection-row")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_main_app_bar, {
        elevation: "5",
        "app-bar-color": "",
        "app-bar-text-color": ""
      }),
      _createVNode(_component_v_main, {
        class: "mainDiv",
        style: _normalizeStyle({ 'background-image': 'url(' + _ctx.baseImg + ')'})
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("section", null, [
              _createVNode(_component_v_container, {
                class: "mb-0 pb-0 px-0 pt-0",
                fluid: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_carousel, {
                    height: _ctx.smAndDown ? '20vh' : '80vh',
                    class: "pb-0",
                    "show-arrows": "hover",
                    cycle: "",
                    "hide-delimiter-background": "",
                    "hide-delimiters": ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banners, (banner, i) => {
                        return (_openBlock(), _createBlock(_component_v_carousel_item, { key: i }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: _ctx.smAndDown ? banner.big : banner.big,
                              class: "carousel-image"
                            }, null, 8, _hoisted_2)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["height"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("section", _hoisted_3, [
              _createVNode(_component_v_container, {
                class: "pt-0 mb-0 pb-0",
                fluid: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    align: "center",
                    justify: "center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        lg: "8",
                        xs: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, { style: {"background-color":"#ffffffa0"} }, {
                            default: _withCtx(() => [
                              _cache[1] || (_cache[1] = _createElementVNode("h1", {
                                class: "queensFont",
                                style: {"text-align":"center","font-size":"45px"}
                              }, "Prémium minőségű gépi hímzés", -1)),
                              _cache[2] || (_cache[2] = _createElementVNode("h2", {
                                class: "pb-6 queensFont",
                                style: {"text-align":"center","font-size":"35px"}
                              }, "Egyedi megoldások cégeknek és magánszemélyeknek", -1)),
                              _createVNode(_component_v_card_text, { class: "playFairFont" }, {
                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                  _createElementVNode("p", {
                                    class: "pb-3",
                                    style: {"font-size":"25px"}
                                  }, " A gépi hímzés az egyik legidőtállóbb és legelegánsabb módja a textíliák díszítésének. Kiváló választás, ha tartós és exkluzív megjelenést szeretnél biztosítani ruházati termékeidnek vagy promóciós ajándékaidnak. ", -1),
                                  _createElementVNode("p", {
                                    class: "pb-3",
                                    style: {"font-size":"25px"}
                                  }, " A hímzett minták nem fakulnak, nem kopnak le, így hosszú távon is megőrzik esztétikai értéküket. ", -1),
                                  _createElementVNode("p", {
                                    class: "pb-3",
                                    style: {"font-size":"25px"}
                                  }, " Modern gépi hímzési technológiánknak köszönhetően részletgazdag, precíz és egyedi mintákat készítünk különböző textíliákra. Legyen szó céges logóról, feliratokról, emblémákról, egyedi grafikákról vagy névre szóló ajándékokról, szakértelmünkkel és korszerű berendezéseinkkel garantáljuk a magas minőségű végeredményt. ", -1),
                                  _createElementVNode("p", { style: {"font-size":"25px"} }, " Szolgáltatásunkkal segítünk kiemelkedni a tömegből, legyen szó egységes vállalati arculatról, személyre szabott ajándékokról vagy exkluzív textil termékekről. ", -1)
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("section", _hoisted_4, [
              _createVNode(_component_v_container, { fluid: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    align: "center",
                    justify: "center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        lg: "8",
                        xs: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            class: "mx-auto",
                            style: {"background-color":"#ffffffa0"}
                          }, {
                            default: _withCtx(() => [
                              _cache[12] || (_cache[12] = _createElementVNode("h1", {
                                class: "queensFont",
                                style: {"text-align":"center","font-size":"45px"}
                              }, " Miért válassz minket ", -1)),
                              _createVNode(_component_v_list, {
                                class: "playFairFont",
                                style: {"background":"#ffffff00"},
                                density: "compact",
                                lines: "three"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item, { style: {"font-size":"25px"} }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        color: "orange",
                                        icon: "mdi-seal"
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _cache[3] || (_cache[3] = _createElementVNode("p", null, [
                                        _createElementVNode("b", null, "Prémium minőség"),
                                        _createTextVNode(" – Modern hímzőgépeinkkel pontos és részletgazdag mintákat készítünk. ")
                                      ], -1))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item, {
                                    color: "primary",
                                    style: {"font-size":"25px"}
                                  }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        color: "purple",
                                        icon: "mdi-arm-flex-outline"
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _cache[4] || (_cache[4] = _createElementVNode("p", null, [
                                        _createElementVNode("b", null, "Tartós kivitelezés"),
                                        _createTextVNode(" – A hímzés ellenáll a kopásnak és mosásnak, így hosszú távon is megőrzi szépségét. ")
                                      ], -1))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item, {
                                    color: "primary",
                                    style: {"font-size":"25px"}
                                  }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        color: "brown",
                                        icon: "mdi-unicode"
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _cache[5] || (_cache[5] = _createElementVNode("p", null, [
                                        _createElementVNode("b", null, "Egyedi igényekre szabva"),
                                        _createTextVNode(" – Legyen szó kis darabszámról vagy nagy tételű gyártásról, rugalmasan alkalmazkodunk az elképzeléseidhez. ")
                                      ], -1))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item, {
                                    color: "primary",
                                    style: {"font-size":"25px"}
                                  }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        color: "blue",
                                        icon: "mdi-tshirt-v"
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _cache[6] || (_cache[6] = _createElementVNode("p", null, [
                                        _createElementVNode("b", null, "Széles anyagválaszték"),
                                        _createTextVNode(" – Pólók, pulóverek, sapkák, munkaruhák, törölközők és sok más textiltermék hímzését vállaljuk. ")
                                      ], -1))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item, {
                                    color: "primary",
                                    style: {"font-size":"25px"}
                                  }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        color: "red",
                                        icon: "mdi-finance"
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _cache[7] || (_cache[7] = _createElementVNode("p", null, [
                                        _createElementVNode("b", null, "Kis és nagy darabszámban is elérhető"),
                                        _createTextVNode(" – Rugalmasan alkalmazkodunk az igényeidhez, legyen szó egyedi darabokról vagy nagyobb megrendelésekről. ")
                                      ], -1))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item, {
                                    color: "primary",
                                    style: {"font-size":"25px"}
                                  }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        color: "indigo",
                                        icon: "mdi-speedometer"
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _cache[8] || (_cache[8] = _createElementVNode("p", null, [
                                        _createElementVNode("b", null, "Gyors és pontos kivitelezés"),
                                        _createTextVNode(" – Hatékony munkafolyamatainknak köszönhetően rövid határidővel vállaljuk a hímzést. ")
                                      ], -1))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item, {
                                    color: "primary",
                                    style: {"font-size":"25px"}
                                  }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        color: "deep-orange",
                                        icon: "mdi-help-circle"
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _cache[9] || (_cache[9] = _createElementVNode("p", null, [
                                        _createElementVNode("b", null, "Segítünk a tervezésben"),
                                        _createTextVNode(" – Ha nincs kész mintád, grafikai támogatást is biztosítunk az elképzelésed megvalósításához. ")
                                      ], -1))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item, {
                                    color: "primary",
                                    style: {"font-size":"25px"}
                                  }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        color: "green-darken-4",
                                        icon: "mdi-cash"
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _cache[10] || (_cache[10] = _createElementVNode("p", null, [
                                        _createElementVNode("b", null, "Versenyképes árak"),
                                        _createTextVNode(" – Kiváló minőséget kínálunk megfizethető áron, hogy a lehető legjobb ár-érték arányt kapd. ")
                                      ], -1))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item, {
                                    color: "primary",
                                    style: {"font-size":"25px"}
                                  }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        color: "teal-darken-4",
                                        icon: "mdi-account-group"
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _cache[11] || (_cache[11] = _createElementVNode("p", null, [
                                        _createElementVNode("b", null, " Céges és magán megrendeléseket is vállalunk"),
                                        _createTextVNode(" – Legyen szó egyedi meglepetésről vagy céges ruházatról, minden ügyfelünk fontos számunkra. ")
                                      ], -1))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("section", null, [
              _createVNode(_component_v_container, { fluid: "" }, {
                default: _withCtx(() => [
                  _cache[33] || (_cache[33] = _createElementVNode("h1", {
                    style: {"text-align":"center","font-size":"45px"},
                    class: "mb-5 queensFont"
                  }, " Gyakran feltett kérdések ", -1)),
                  _createVNode(_component_v_row, {
                    class: "playFairFont",
                    align: "center",
                    justify: "center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        lg: "8",
                        xs: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expansion_panels, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel_title, {
                                    style: {"font-size":"25px"},
                                    "collapse-icon": "mdi-minus",
                                    "expand-icon": "mdi-plus"
                                  }, {
                                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                                      _createTextVNode(" Mi az a gépi hímzés? ")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_expansion_panel_text, null, {
                                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                                      _createTextVNode(" A gépi hímzés egy automatizált folyamat, amely során számítógép-vezérelt hímzőgép szálakkal mintát varr textilre. Ez lehet logó, szöveg, grafika vagy bármilyen egyedi motívum. ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel, { class: "mt-5" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel_title, {
                                    style: {"font-size":"25px"},
                                    "collapse-icon": "mdi-minus",
                                    "expand-icon": "mdi-plus"
                                  }, {
                                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                                      _createTextVNode(" Mire lehet gépi hímzést használni? ")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_expansion_panel_text, null, {
                                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                                      _createTextVNode(" Leggyakrabban: "),
                                      _createElementVNode("br", null, null, -1),
                                      _createTextVNode(" Céges pólók, ingek, kabátok logózására "),
                                      _createElementVNode("br", null, null, -1),
                                      _createTextVNode(" Egyenruhák, munkaruhák díszítésére "),
                                      _createElementVNode("br", null, null, -1),
                                      _createTextVNode(" Törölközők, köntösök, sapkák, táskák, zászlók személyre szabására "),
                                      _createElementVNode("br", null, null, -1),
                                      _createTextVNode(" Egyedi ajándéktárgyak készítésére ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel, { class: "mt-5" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel_title, {
                                    style: {"font-size":"25px"},
                                    "collapse-icon": "mdi-minus",
                                    "expand-icon": "mdi-plus"
                                  }, {
                                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                                      _createTextVNode(" Milyen anyagokra lehet hímezni? ")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_expansion_panel_text, null, {
                                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                                      _createTextVNode(" Szinte minden textilre: pamut, poliészter, frottír, vászon, softshell, filc stb. Vastagabb anyagokra (pl. polár, dzseki) is lehet hímzést készíteni, csak a minta kialakításánál figyelembe kell venni az anyag tulajdonságait. ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel, { class: "mt-5" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel_title, {
                                    style: {"font-size":"25px"},
                                    "collapse-icon": "mdi-minus",
                                    "expand-icon": "mdi-plus"
                                  }, {
                                    default: _withCtx(() => _cache[19] || (_cache[19] = [
                                      _createTextVNode(" Hogyan kell a mintát elküldeni? ")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_expansion_panel_text, null, {
                                    default: _withCtx(() => _cache[20] || (_cache[20] = [
                                      _createTextVNode(" A legjobb, ha vektoros formátumban (pl. .ai, .eps, .svg, .cdr) küldöd el a logót vagy mintát. Ha ez nem elérhető, akkor jó minőségű .jpg vagy .png is megfelel, de ilyenkor plusz digitalizálásra lehet szükség. ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel, { class: "mt-5" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel_title, {
                                    style: {"font-size":"25px"},
                                    "collapse-icon": "mdi-minus",
                                    "expand-icon": "mdi-plus"
                                  }, {
                                    default: _withCtx(() => _cache[21] || (_cache[21] = [
                                      _createTextVNode(" Mi az a digitalizálás? ")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_expansion_panel_text, null, {
                                    default: _withCtx(() => _cache[22] || (_cache[22] = [
                                      _createTextVNode(" A digitalizálás az a folyamat, amikor a grafikai mintát átalakítjuk hímzőgéppel olvasható formátumra (pl. .dst, .emb, .pes). Ez nem ugyanaz, mint egy képfájl megnyitása: a minta minden öltését, irányát és típusát meg kell határozni. ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel, { class: "mt-5" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel_title, {
                                    style: {"font-size":"25px"},
                                    "collapse-icon": "mdi-minus",
                                    "expand-icon": "mdi-plus"
                                  }, {
                                    default: _withCtx(() => _cache[23] || (_cache[23] = [
                                      _createTextVNode(" Mennyibe kerül a gépi hímzés? ")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_expansion_panel_text, null, {
                                    default: _withCtx(() => _cache[24] || (_cache[24] = [
                                      _createTextVNode(" Az ár több tényezőtől függ: "),
                                      _createElementVNode("br", null, null, -1),
                                      _createTextVNode(" A minta mérete és bonyolultsága "),
                                      _createElementVNode("br", null, null, -1),
                                      _createTextVNode(" Hány darabot kell hímezni "),
                                      _createElementVNode("br", null, null, -1),
                                      _createTextVNode(" Milyen anyagra kerül a hímzés "),
                                      _createElementVNode("br", null, null, -1),
                                      _createTextVNode(" Egyszeri digitalizálási díj (ha még nincs kész minta) ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel, { class: "mt-5" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel_title, {
                                    style: {"font-size":"25px"},
                                    "collapse-icon": "mdi-minus",
                                    "expand-icon": "mdi-plus"
                                  }, {
                                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                                      _createTextVNode(" Van minimális rendelési mennyiség? ")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_expansion_panel_text, null, {
                                    default: _withCtx(() => _cache[26] || (_cache[26] = [
                                      _createTextVNode(" Általában nincs, de 1-2 darab esetén magasabb az egységár, mivel a gép beállítása és a digitalizálás ugyanannyi időt igényel, mint nagyobb tételnél. ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel, { class: "mt-5" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel_title, {
                                    style: {"font-size":"25px"},
                                    "collapse-icon": "mdi-minus",
                                    "expand-icon": "mdi-plus"
                                  }, {
                                    default: _withCtx(() => _cache[27] || (_cache[27] = [
                                      _createTextVNode(" Mennyi idő alatt készül el a hímzés? ")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_expansion_panel_text, null, {
                                    default: _withCtx(() => _cache[28] || (_cache[28] = [
                                      _createTextVNode(" Átlagosan 3-10 munkanap, de sürgős megrendeléseknél előzetes egyeztetés után gyorsabb határidő is lehetséges. ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel, { class: "mt-5" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel_title, {
                                    style: {"font-size":"25px"},
                                    "collapse-icon": "mdi-minus",
                                    "expand-icon": "mdi-plus"
                                  }, {
                                    default: _withCtx(() => _cache[29] || (_cache[29] = [
                                      _createTextVNode(" Mosható-e a gépi hímzés? ")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_expansion_panel_text, null, {
                                    default: _withCtx(() => _cache[30] || (_cache[30] = [
                                      _createTextVNode(" Igen, a hímzés nagyon tartós. Jellemzően 60 °C-ig mosható, nem kopik le, nem fakul el, mint a nyomott minták. Az anyag kezelési útmutatóját azért érdemes követni. ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel, { class: "mt-5" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel_title, {
                                    style: {"font-size":"25px"},
                                    "collapse-icon": "mdi-minus",
                                    "expand-icon": "mdi-plus"
                                  }, {
                                    default: _withCtx(() => _cache[31] || (_cache[31] = [
                                      _createTextVNode(" Lehet-e színes mintát is hímezni? ")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_expansion_panel_text, null, {
                                    default: _withCtx(() => _cache[32] || (_cache[32] = [
                                      _createTextVNode(" Igen, a gépi hímzés többféle színű cérnával dolgozik. Egyszerre általában 10-15 szín használható, de a legtöbb logóhoz ez bőven elegendő. ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("section", null, [
              _createVNode(_component_v_container, { fluid: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    align: "center",
                    justify: "center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        lg: "8",
                        xs: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, { style: {"background-color":"#ffffffa0"} }, {
                            default: _withCtx(() => [
                              _cache[34] || (_cache[34] = _createElementVNode("h1", {
                                style: {"text-align":"center","font-size":"45px"},
                                class: "queensFont mb-5"
                              }, " Lépjen kapcsolatba velünk ", -1)),
                              _createVNode(_component_connection_row)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_v_footer, { class: "bg-indigo-lighten-1 d-flex flex-column playFairFont" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _cache[35] || (_cache[35] = _createElementVNode("strong", null, "Kövess minket", -1)),
                  _createVNode(_component_v_spacer),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icons, (icon) => {
                    return (_openBlock(), _createBlock(_component_v_btn, {
                      key: icon,
                      icon: icon,
                      class: "mx-4",
                      size: "small",
                      variant: "plain"
                    }, null, 8, ["icon"]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createTextVNode(_toDisplayString(new Date().getFullYear()) + " — ", 1),
                  _cache[36] || (_cache[36] = _createElementVNode("strong", null, "Kreatív hímzőkuckó", -1))
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}